import styled from 'styled-components';

export const Header = styled.div<{ showBreadcrumbs: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  padding-top: ${({ showBreadcrumbs }) => (showBreadcrumbs ? '0' : '1.5rem')};
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  & > .hefesto-title h1 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 1rem;
  }
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const HeaderActionWraper = styled.form`
  margin-top: 1.5rem;
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
`;

export const SearchFieldWrapper = styled.div`
  width: 35.25rem;
`;
